/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clubs_Directory_IntroInputs */

const en_us2_clubs_directory_intro = /** @type {(inputs: Clubs_Directory_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clubs whose admin opened the ranking.`)
};

const pt_br2_clubs_directory_intro = /** @type {(inputs: Clubs_Directory_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clubes cujo admin deixou o ranking aberto.`)
};

const es_419_clubs_directory_intro = /** @type {(inputs: Clubs_Directory_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clubes cuyo admin abrió el ranking.`)
};

const pt_pt2_clubs_directory_intro = /** @type {(inputs: Clubs_Directory_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clubes cujo admin abriu a classificação.`)
};

const fr_fr2_clubs_directory_intro = /** @type {(inputs: Clubs_Directory_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clubs dont l'admin a ouvert le classement.`)
};

const de_de2_clubs_directory_intro = /** @type {(inputs: Clubs_Directory_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clubs, deren Admin die Rangliste geöffnet hat.`)
};

const it_it2_clubs_directory_intro = /** @type {(inputs: Clubs_Directory_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Club il cui admin ha aperto la classifica.`)
};

/**
* | output |
* | --- |
* | "Clubs whose admin opened the ranking." |
*
* @param {Clubs_Directory_IntroInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const clubs_directory_intro = /** @type {((inputs?: Clubs_Directory_IntroInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clubs_Directory_IntroInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_clubs_directory_intro(inputs)
	if (locale === "es-419") return es_419_clubs_directory_intro(inputs)
	if (locale === "pt-PT") return pt_pt2_clubs_directory_intro(inputs)
	if (locale === "fr-FR") return fr_fr2_clubs_directory_intro(inputs)
	if (locale === "de-DE") return de_de2_clubs_directory_intro(inputs)
	if (locale === "it-IT") return it_it2_clubs_directory_intro(inputs)
	return en_us2_clubs_directory_intro(inputs)
});
export { clubs_directory_intro as "clubs.directory_intro" }